(function (scope) {
  'use strict';

  const timeZone = 'America/Santiago';
  const selector = '[data-td-delivery-promise]';
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  let formatter;

  function stateAt(value) {
    const date = value === undefined ? new Date() : new Date(value);
    if (!Number.isFinite(date.getTime())) return { key: 'fallback', timeZone };
    try {
      if (!formatter) {
        formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone,
          weekday: 'short',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });
      }
      const parts = Object.fromEntries(formatter.formatToParts(date).map((part) => [part.type, part.value]));
      const day = weekdays.indexOf(parts.weekday);
      const hour = Number(parts.hour);
      if (day < 0 || !Number.isInteger(hour) || hour < 0 || hour > 23) return { key: 'fallback', timeZone };
      const localDate = [parts.year, parts.month, parts.day].join('-');
      const holidayMonday = localDate === '2026-10-31';
      const key = holidayMonday || day === 0 || (day === 6 && hour >= 10) ? 'monday' : hour < 10 ? 'today' : 'tomorrow';
      return { key, day, hour, minute: Number(parts.minute), second: Number(parts.second), timeZone };
    } catch (_) {
      return { key: 'fallback', timeZone };
    }
  }

  function textFor(state, mode, messages) {
    const copy = messages || {};
    const key = state && state.key ? state.key : 'fallback';
    const rm = copy[key] || copy.fallback || '';
    if (mode === 'rm') return rm;
    if (mode === 'regions') return copy.regions || '';
    if (mode === 'schedule') return copy.schedule || '';
    if (mode === 'detail') return copy[key + '_detail'] || copy.schedule || copy.fallback || '';
    return [rm, copy.regions].filter(Boolean).join(' · ');
  }

  const api = { stateAt, textFor, refresh: function () {} };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!scope.document || scope.TDDeliveryPromise) return;
  scope.TDDeliveryPromise = api;

  const document = scope.document;
  const markers = new Set();
  let messages;
  let timer;

  function readMessages() {
    const config = document.getElementById('td-delivery-messages');
    if (!config) return;
    try {
      const parsed = JSON.parse(config.textContent);
      if (parsed && typeof parsed === 'object' && typeof parsed.fallback === 'string') messages = parsed;
    } catch (_) {}
  }

  function collect(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches(selector)) markers.add(root);
    root.querySelectorAll(selector).forEach((node) => markers.add(node));
  }

  function refresh(root) {
    if (!messages) readMessages();
    if (root && root.nodeType === 1) collect(root);
    if (!messages) return;
    const state = stateAt();
    markers.forEach((node) => {
      if (!node.isConnected || !node.matches(selector)) {
        markers.delete(node);
        return;
      }
      const text = textFor(state, node.dataset.tdDeliveryPromise, messages);
      if (text && node.textContent !== text) node.textContent = text;
      if (node.dataset.tdDeliveryState !== state.key) node.dataset.tdDeliveryState = state.key;
    });
  }

  function schedule() {
    scope.clearTimeout(timer);
    if (document.visibilityState === 'hidden') return;
    const now = Date.now();
    timer = scope.setTimeout(function () {
      refresh();
      schedule();
    }, 60000 - (now % 60000));
  }

  function resume() {
    if (document.visibilityState !== 'hidden') refresh();
    schedule();
  }

  function start() {
    readMessages();
    collect(document.body);
    refresh();
    schedule();
    if (scope.MutationObserver) {
      const observer = new scope.MutationObserver(function (records) {
        let changed = false;
        records.forEach((record) => {
          record.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            collect(node);
            changed = true;
          });
          if (record.removedNodes.length) changed = true;
        });
        if (changed) refresh();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', resume);
    scope.addEventListener('pageshow', resume);
    document.addEventListener('shopify:section:load', function (event) {
      readMessages();
      refresh(event.target);
    });
  }

  api.refresh = refresh;
  api.message = function (mode) {
    if (!messages) readMessages();
    return textFor(stateAt(), mode, messages);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})(typeof window !== 'undefined' ? window : globalThis);
